/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Status
 */
export type GetCardTransactionDetailsResponseDataItemStatus = typeof GetCardTransactionDetailsResponseDataItemStatus[keyof typeof GetCardTransactionDetailsResponseDataItemStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCardTransactionDetailsResponseDataItemStatus = {
  SUCCESS: 'SUCCESS',
  PENDING: 'PENDING',
  VOID: 'VOID',
  DECLINED: 'DECLINED',
} as const;
